export default __webpack_public_path__ + "static/media/contact-file-icon-black.a6d31652.svg";